<template>
    <!--
        Modal component.
        Displays content inside a layer above the page content.
        Closable by clicking button OKAY, background-layer or pressing esc-key
    -->
    <div class="modal">
        <transition name="fade">
            <div class="modal-background" @click.stop="close" v-if="show"></div>
        </transition>

        <transition name="slide-top">
            <div class="modal-content" :class="wide ? 'modal-content--wide' : null" v-if="show">
                <div class="head" v-if="headline !== ''">
                    <h2 v-html="headline"></h2>
                </div>

                <div v-if="content" :class="blank ? 'body body--blank' : 'body'" v-html="content"></div>

                <div class="modal-footer">
                    <action @click.native="print()" color="blue" style="float:left" v-if="printable">
                        {{ $t('label.print') }}
                    </action>
                    <action @click.native="close()" color="green" focus>
                        OKAY
                    </action>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import events from '../../events/events';

export default
{
    name: 'Modal',

    data() {
        return {
            show: false,
            headline: '',
            content: '',
            callback: null,
            blank: false,
            wide: false,
            printable: false,
        }
    },

    created()
    {
        /**
         * Open modal dialog.
         * Adds event listener to window object for key esc
         *
         * @param {String} headline
         * @param {String} content
         * @param {Function} callback
         */
        events.$on('modal.open', (headline, content, callback, blank, wide) =>
        {
            this.headline = headline || '';
            this.content = content;
            this.callback = callback;
            this.blank = blank ? true : false;
            this.wide = wide ? true : false;

            this.show = true;

            window.addEventListener('keyup', this.closeEsc, false);
        });

        events.$on('modal.close', () =>
        {
            this.close();
        });

        events.$on('modal.printable', setting =>
        {
            this.printable = setting;
        });
    },

    methods:
    {
        /**
         * Close dialog and remove event listener from window
         */
        close()
        {
            window.removeEventListener('keyup', this.closeEsc, false);

            this.show = false;

            if (this.$widget.inactive) this.$widget.activate();

            if (typeof this.callback == 'function') this.callback();

            this.headline = '';
            this.content = '';
            this.callback = null;
        },

        /**
         * Triggers close method
         *
         * @param {Object} e
         */
        closeEsc(e) {
            if (e.keyCode === 27) {
                this.close();
            }
        },

        print()
        {
            let win = window.open();
            win.document.write(this.content)
            win.print()
        }
    }
}
</script>



// WEBPACK FOOTER //
// Modal.vue?2cbad728